import { z } from 'zod';
import { OrderDirection } from '@/constants/orderDirection';
import type { StoreSentOrdersQuery } from './-api/orders';
export const OrderBy = {
  ACCEPTED_DATE: 'ACCEPTED_DATE',
  ORDER_NUMBER: 'ORDER_NUMBER',
  ORDERED_BY_PERSON: 'ORDERED_BY_PERSON',
  CUSTOMER: 'CUSTOMER',
  SUPPLIER: 'SUPPLIER',
  DELIVERY_DATE: 'DELIVERY_DATE'
} as const satisfies Record<string, StoreSentOrdersQuery['orderBy']>;
export const Category = {
  UNTOUCHED: 'UNTOUCHED',
  ACCEPTED: 'ACCEPTED',
  CANCELED: 'CANCELED',
  ALL: 'ALL'
} as const satisfies Record<string, StoreSentOrdersQuery['category']>;
export const SearchSchema = z.object({
  category: z.nativeEnum(Category).default(Category.UNTOUCHED),
  page: z.number().int().positive().default(1),
  pageSize: z.number().int().positive().default(100),
  orderBy: z.nativeEnum(OrderBy).default(OrderBy.ORDER_NUMBER),
  orderDirection: z.nativeEnum(OrderDirection).default(OrderDirection.DESC),
  freeText: z.string().optional(),
  sentAtFrom: z.string().datetime().optional(),
  sentAtTo: z.string().datetime().optional(),
  acceptedAtFrom: z.string().datetime().optional(),
  acceptedAtTo: z.string().datetime().optional(),
  canceledAtFrom: z.string().datetime().optional(),
  canceledAtTo: z.string().datetime().optional()
});
export type SearchSchema = z.infer<typeof SearchSchema>;